<template>
  <v-app>
    <v-row no-gutters style="min-height: 100vh;">
      <v-col cols="12" class="d-flex justify-center align-center">
        <v-card class="pa-4 login-card" max-width="600" elevation="10" rounded>
          <div class="text-center logo-container">
            <v-img
              src="@/assets/logo_fisioconecta.png"
              alt="Logo Fisio Conecta"
              max-width="200"
              class="mx-auto mb-8"
              contain
            />
            <div class="caption grey--text mt-4">Entre com suas credenciais para acessar o painel administrativo</div>
          </div>
          <v-form ref="form">
            <v-text-field
              label="Email"
              prepend-inner-icon="mdi-email-outline"
              type="email"
              outlined
              dense
              class="mb-1"
              v-model="email"
              required
              :rules="[v => !!v || 'Digite o email']"                             
            />
            <v-text-field
              label="Senha"
              prepend-inner-icon="mdi-lock-outline"
              :type="showPassword ? 'text' : 'password'"
              outlined
              dense
              class="mb-1"
              v-model="password"
              required
              :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off-outline'"
              @click:append="showPassword = !showPassword"
              :rules="[v => !!v || 'Digite a senha']"
            />
            <v-alert v-if="error" type="error" dense>{{ error }}</v-alert>
            <v-btn color="#1b6390" class="white--text mb-4" block large type="button" :loading="loading" @click="fazerLogin">
              Entrar
            </v-btn>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
  </v-app>
</template>

<script>

// import firebase from 'firebase/app'
import 'firebase/auth'

export default {
  name: "Login",
  data() {
    return {
      email: '',
      password: '',
      showPassword: false
    }
  },
  watch: {
    authenticated(val) {
      if (val) {
        this.$router.push('/fisioterapeutas')
      }
    }
  },
  computed: {
    error() {
      return this.$store.getters.error ? (this.$store.getters.error.message || this.$store.getters.error) : ''
    },
    success() {
      return this.$store.getters.success
    },
    loading() {
      return this.$store.getters.loading
    },
    authenticated() {
      return this.$store.state.authenticated
    }
  },
  methods: {
    fazerLogin () {
      if (this.$refs.form.validate()) {
        this.$store.dispatch('signUserIn', { email: this.email, password: this.password })
      }
    },
    // async forgotPassword() {
    //   this.error = ''
    //   this.success = ''
    //   if (!this.email) {
    //     this.error = 'Digite seu email para redefinir a senha.'
    //     return
    //   }
    //   try {
    //     await firebase.auth().sendPasswordResetEmail(this.email)
    //     this.success = 'Email de redefinição enviado!'
    //   } catch (e) {
    //     this.error = 'Erro ao enviar email de redefinição.'
    //   }
    // }
  }
}
</script>

<style scoped>
.login-card {
  border-radius: 18px !important;
}
.logo-container {
  margin-bottom: 32px;
}
@media (max-width: 600px) {
  .login-card {
    box-shadow: none !important;
    border: none !important;
    border-radius: 0 !important;
    padding: 16px !important;
    max-width: 100vw !important;
  }
  .logo-container {
    margin-top: -24px;
    margin-bottom: 24px;
  }
  .v-img {
    max-width: 120px !important;
  }
}
</style>